import { Modal} from 'bootstrap';
import CaptchaInput from "./cms-captcha";

export default class SystemsightAjaxFormHandler {
    constructor(options) {
        let defaults = {
            version: '1.1.1',
            formSelector: '[data-type="ajax"]',
            submitSelector: 'button[type="submit"]',
            preloaderElement: ' <div class="preloader spinner-border spinner-border-sm" role="status"><span class="sr-only">...</span></div>'
        };
        this.formsIterator = 0;
        this.options = $.extend(true, {}, defaults, (options || {}));

        this.init();
    }
    init(){
        var that = this;
        //start listening for submits
        $('body').on('submit', that.options.formSelector,function (e, data) {
            if(!$(this).attr('id')) {
                $(this).attr('id', 'ss_' + (++that.formsIterator));
            }
            that.handle_form_submit($(this), $(this).data('submit_invoker'), data);
            return false;
        }).on('click', that.options.formSelector + ' button[type="submit"]',function (e) {
            //sets submit action invoker
            $(this.form).data('submit_invoker', $(this));
        }).on('click', that.options.formSelector + ' input[type="submit"][formaction]',function (e) {
            //sets submit action invoker
            $(this.form).data('submit_invoker', $(this));
        });

        console.log('SystemsightAjaxFormHandler inited (' + this.options.version + ')');
    }

    find_submit_btn($form, $button = null){
        var that = this;
        if(!$button){
            $button = $form.find(that.options.submitSelector);
        }
        return $button;
    }

    handle_form_submit($form, $button = null, extraData = null) {
        var that = this;
        that.show_preloader($form, $button);
        that.remove_form_feedbacks($form);

        var formData = $form.serializeArray();

        if($button && $button.attr('name')){
            formData.push(
                {
                    name: $button.attr('name'),
                    value: $button.val()
                }
            );
        }

        if(extraData){
            for (var k in extraData){
                formData.push(
                    {
                        name: k,
                        value: extraData[k]
                    }
                );
            }
        }

        var action = $form.attr('action');
        if ($button && $button.attr('formaction')) {
            action = $button.attr('formaction');
        }

        $form.trigger('before-submit', formData);
        $.post(action, formData).done(function (r) {
            $form.trigger('after-submit', r);
            that.handle_form_submit_done($form, r);
        }).always(function (e) {
            $form = that.get_updated_form_element($form);
            that.hide_preloader($form, $button);
            that.handle_form_submit_always($form);
        }).fail(function (e) {
            $form.trigger('submit-fail');
            that.handle_form_submit_fail($form, e);
        });
    };

    show_preloader($form, $button) {
        var that = this;
        $button = that.find_submit_btn($form, $button);

        if($button.find('.preloader').length === 0){
            $button.append(that.options.preloaderElement);
        }
        $form.find(that.options.submitSelector)
            .attr("disabled", "disabled");

        $button.find('.preloader').removeClass('d-none');
    };
    hide_preloader($form, $button) {
        var that = this;
        $button = that.find_submit_btn($form, $button);
        $form.find(that.options.submitSelector)
            .attr("disabled", null)
            .find('.preloader').addClass('d-none')
        ;
    };
    remove_form_feedbacks($form) {
        var that = this;
        $form.find('input,select,textarea')
            .removeClass('is-invalid is-valid')
            .parents('.form-group').find('.invalid-feedback').html('')
        ;

        //jei tai simplemodule forma, tai tabus papildomai perziurim
        if($form.hasClass('simplemodule-form')){
            $form.find(".sm-edit-tabs a.nav-link").removeClass('is-invalid');
        }
    };
    handle_form_submit_always($form) {
        var that = this;
        //reload captcha
        $form.find('input.captcha-input').each(function () {
            var jInput = $(this);

            jInput.val('');
            if(!jInput.data('captchaInstance')) {
                CaptchaInput.init();
            } else {
                jInput.data('refresh')();
            }
        });
        //update fancybox
        if($form.parents('.fancybox-wrap').length){
            $.fancybox.update()
        }
    }
    handle_form_submit_fail($form, event) {
        var that = this;
        that.display_messages($form, {
            message: {
                type: 'danger',
                text: event.status + " " + event.statusText
            }
        });
    };
    handle_form_submit_done($form, response) {
        var that = this;

        if(typeof response === 'string'){
            that.display_messages($form, {
                message: {
                    type: 'danger',
                    text: response
                }
            });
            return;
        }

        if(response.status == "ok"){
        }else{
            for(var fieldName in response.errors){
                var $field = $form.find('[name="'+fieldName+'"],[name="'+fieldName+'[]"],[data-input_name="'+fieldName+'"]');
                $field.addClass('is-invalid').parents('.form-group').find('.invalid-feedback')
                    .html(response.errors[fieldName])
                    .addClass('d-block')
                ;
            }
        }

        if(typeof response.transformed_data === 'object'){
            for(var fieldName in response.transformed_data){
                var $field = $form.find('[name="'+fieldName+'"],[data-input_name="'+fieldName+'"]');
                //todo: check radio or checkbox types
                $field.val(response.transformed_data[fieldName]);
            }
        }

        if(typeof response.message !== 'undefined'){
            that.display_messages($form, response);
        }

        if(typeof response.modal === 'string'){
            that.display_modal($form, response.modal, response);
        }

        if(typeof response.modal_body === 'string'){
            that.display_modal(
                $form,
                that.get_modal_html(response.modal_body),
                response
            );
        }

        if(typeof response.replace_with === "string"){
            var $r = $(response.replace_with);

            if(response.target){
                $(response.target).replaceWith($r);
            }else{
                $form.replaceWith($r);
                $form = $r;
            }
        }

        if(typeof response.callback === 'string'){
            eval(response.callback)
        }

        if(response.init_captcha === true) {
            CaptchaInput.init();
        }

        if(typeof response.redirect === "string"){
            window.location.href = response.redirect;
        }

        if(response.reload_parent === true){
            parent.window.location.reload();
        }
    };
    get_updated_form_element($form) {
        if($form.attr('id')) {
            return $('#' + $form.attr('id')); //Select updated DOM element
        } else {
            return $form;
        }
    };
    display_modal($form, modal, response){
        var $modal = $(modal);
        $('body').append($modal);
        let bsModal = new Modal($modal[0], {});

        var redirect = null;
        //padarom redirecta tik poto kai uzdaromas modal'as
        if(typeof response.redirect === 'string') {
            redirect = response.redirect
            delete response.redirect;
        }

        $modal.on('hidden.bs.modal', function (event) {
            bsModal.dispose();
            $modal.remove();

            if(redirect){
                window.location.href = redirect;
            }
        })
        bsModal.show();
    };
    display_messages($form, response){
        var that = this;
        var modalBody = '';
        if(typeof response.message == "object"){
            if(Array.isArray(response.message )){
                if(response.message.length){
                    $.each(response.message, function (index, msg) {
                        if(typeof msg == "object"){
                            modalBody += '<div class="alert alert-'+msg.type+'">'+msg.text+'</div>';
                        }else{
                            modalBody += '<div class="alert alert-info">'+msg+'</div>';
                        }
                    })
                }

            }else{
                modalBody += '<div class="alert alert-'+response.message.type+'">'+response.message.text+'</div>';
            }
        }else{
            modalBody += '<div class="alert alert-info">'+response.message+'</div>';
        }

        if(modalBody){
            that.display_modal($form, that.get_modal_html(modalBody), response);
        }
    }

    get_modal_html(modalBody) {
        var that = this;
        var modalHtml =
            '<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="responseModalLabel" aria-hidden="true">'
            + '<div class="modal-dialog" role="document">'
            + '<div class="modal-content">'
            //+ '<div class="modal-header">'
            //+ '<h5 class="modal-title" id="responseModalLabel">&nbsp;</h5>'
            //+ '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><span class="sr-only" aria-hidden="true">&times;</span></button>'
            //+ '</div>'
            + '<div class="modal-body">'+modalBody+'</div>'
            + '<div class="modal-footer">'
            + '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ok</button>'
            + '</div>'
            + '</div>'
            + '</div>'
            + '</div>'
        ;

        return modalHtml;
    };
}

var systemsightAjaxFormHandler = new  SystemsightAjaxFormHandler();

//export default systemsightAjaxFormHandler;
